import { computed, getCurrentInstance } from '@vue/composition-api';

export function useChartingRoute() {
  const instance = getCurrentInstance();
  const vm = instance && instance.proxy;

  return {
    get name() { return vm && vm.$route ? vm.$route.name : ''; },
    get params() { return vm && vm.$route ? vm.$route.params : {}; },
    get query() { return vm && vm.$route ? vm.$route.query : {}; },
    get fullPath() { return vm && vm.$route ? vm.$route.fullPath : ''; },
    get path() { return vm && vm.$route ? vm.$route.path : ''; },
    revision: computed(() => (vm && vm.$route ? vm.$route.fullPath : ''))
  };
}

export function useChartingRouter() {
  const instance = getCurrentInstance();
  const vm = instance && instance.proxy;
  return vm ? vm.$router : null;
}
